import React, { useState } from 'react';

const LogoItem = ({ company }) => {
    const [imgError, setImgError] = useState(false);

    if (imgError || !company.logo) {
        return (
            <div className="flex items-center justify-center min-w-[max-content] h-14 px-8 bg-brand-bg border border-gray-800 rounded-xl hover:border-brand-gold/30 hover:shadow-[0_0_15px_rgba(255,184,28,0.1)] transition-all duration-300">
                <span className="text-xl font-bold text-brand-textMuted hover:text-brand-gold transition-colors select-none tracking-wide">
                    {company.name}
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-w-[160px] h-20 transition-all duration-300 px-6">
            <img
                src={company.logo}
                alt={company.name}
                className="max-h-16 max-w-[160px] object-contain opacity-90 hover:opacity-100 hover:scale-110 transition-all duration-300"
                onError={() => setImgError(true)}
            />
        </div>
    );
};

const CompanyLogos = () => {
    const companies = [
        { name: "Amar Prerna Trust" },
        { name: "Juspay" },
        { name: "Wildrex Solutions" },
        { name: "Celebal Technologies" },
        { name: "Smart Analytica" },
        { name: "Setoo" },
        { name: "Avalara Technologies Pvt. Ltd." },
        { name: "Evonence Pvt. Ltd." },
        { name: "Benchmark IT Solutions" },
        { name: "OneNet Solutions Pvt. Ltd." },
        { name: "SCharge Pvt. Ltd." },
        { name: "Morningstar Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Morningstar_Logo.svg" },
        { name: "ScatterPie Analytics" },
        { name: "Winjit Technologies Pvt. Ltd." },
        { name: "Avaloq Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/0/07/Avaloq_logo.svg" },
        { name: "Prosper InfoTech Pvt. Ltd." },
        { name: "Jainson Infotech Pvt. Ltd." },
        { name: "NewPage Solutions Pvt. Ltd." },
        { name: "Borderline Genius Inc." },
        { name: "Wisen InfoTech Pvt. Ltd." },
        { name: "AutometanAI Pvt. Ltd." },
        { name: "Netwin Systems and Solutions Pvt. Ltd." },
        { name: "Celebals Pvt. Ltd." },
        { name: "ScatterPie Analytics Pvt. Ltd." },
        { name: "Vision Waves Pvt. Ltd." },
        { name: "Infosys Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg" },
        { name: "Celebal Technology Ltd." },
        { name: "Philips India Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/5/52/Philips_logo_new.svg" },
        { name: "Wesco Anixter Pvt. Ltd." },
        { name: "Remiges Technologies Pvt. Ltd." },
        { name: "HumanCloud" },
        { name: "Capgemini", logo: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Capgemini_201x_logo.svg" },
        { name: "Godrej InfoTech Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/5/53/Godrej_Logo.svg" },
        { name: "Deloitte Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/5/56/Deloitte.svg" },
        { name: "Tata Consultancy Services (TCS)", logo: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Tata_Consultancy_Services_Logo.svg" },
        { name: "Vashi Integrated Solutions" },
        { name: "Synechron Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/d/df/Synechron_Logo.svg" },
        { name: "Assimilate Technologies Pvt. Ltd." },
        { name: "LST Consultancy Pvt. Ltd." },
        { name: "Prorigo Software Pvt. Ltd." },
        { name: "Johnson Controls", logo: "https://upload.wikimedia.org/wikipedia/commons/8/87/Johnson_Controls_Logo.svg" },
        { name: "Lumens Technologies Pvt. Ltd." },
        { name: "Mindtree Pvt. Ltd.", logo: "https://upload.wikimedia.org/wikipedia/commons/9/9c/Mindtree_logo.svg" },
        { name: "Findability Sciences Pvt. Ltd." },
        { name: "The Maverics Technologies Pvt. Ltd." }
    ];

    return (
        <div className="bg-brand-card py-10 border-y border-gray-800 overflow-hidden relative">
            <div className="max-w-7xl mx-auto px-6 mb-10 text-center">
                <h2 className="text-3xl font-semibold text-brand-textLight">Our Students Are Placed At</h2>
            </div>

            {/* Gradient Fades for Smooth Scroll Effect */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-brand-card to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-brand-card to-transparent z-10 pointer-events-none"></div>

            <div className="relative flex overflow-x-hidden">
                <div className="flex w-max animate-scroll whitespace-nowrap py-4 items-center" style={{ animationDuration: '80s' }}>
                    {/* Duplicate the list to ensure seamless scrolling */}
                    {[...Array(2)].map((_, i) => (
                        <div key={i} className="flex space-x-12 mx-6 items-center">
                            {companies.map((company, index) => (
                                <LogoItem key={`${i}-${index}`} company={company} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CompanyLogos;
